import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Box,
  Button,
  VStack,
  HStack,
  Text,
  Icon,
} from "@chakra-ui/react";
import { FaKey, FaClock, FaExclamationTriangle } from "react-icons/fa";

/**
 * Componente de alerta para erros de licença
 */
const LicenseErrorAlert = ({ 
  error, 
  onRetry, 
  onBack, 
  context = "realizar operação",
  showRetry = true,
  showBack = true 
}) => {
  // Verificar se é erro de licença
  const isLicenseError = error && 
    error.message && 
    error.message.includes("licenca");

  if (!isLicenseError) {
    return null;
  }

  return (
    <Box
      maxW="600px"
      mx="auto"
      bg="white"
      borderRadius="2xl"
      boxShadow="2xl"
      border="1px solid"
      borderColor="red.100"
      overflow="hidden"
    >
      {/* Header do erro */}
      <Box
        bg="red.500"
        p={6}
        textAlign="center"
      >
        <VStack spacing={3}>
          <Icon as={FaKey} color="white" boxSize={8} />
          <Text fontSize="2xl" fontWeight="bold" color="white">
            Erro de Licença
          </Text>
          <Text fontSize="md" color="red.100" opacity={0.9}>
            Servidor de licenças indisponível
          </Text>
        </VStack>
      </Box>

      {/* Corpo do erro */}
      <Box p={8}>
        <VStack spacing={6} align="stretch">
          {/* Descrição do erro */}
          <Alert status="error" borderRadius="lg">
            <AlertIcon />
            <Box>
              <AlertTitle>Licença Indisponível</AlertTitle>
              <AlertDescription>
                Não há licenças disponíveis no servidor no momento para {context}.
              </AlertDescription>
            </Box>
          </Alert>

          {/* Informações adicionais */}
          <Box
            bg="orange.50"
            p={4}
            borderRadius="lg"
            border="1px solid"
            borderColor="orange.200"
          >
            <VStack spacing={3} align="start">
              <HStack spacing={2}>
                <Icon as={FaExclamationTriangle} color="orange.500" />
                <Text fontSize="sm" fontWeight="medium" color="orange.700">
                  O que isso significa?
                </Text>
              </HStack>
              <Text fontSize="sm" color="orange.600" lineHeight="tall">
                O servidor de licenças está temporariamente indisponível ou todas as licenças 
                estão sendo utilizadas por outros usuários. Este é um problema temporário 
                que deve ser resolvido em alguns minutos.
              </Text>
            </VStack>
          </Box>

          {/* Ações recomendadas */}
          <Box
            bg="blue.50"
            p={4}
            borderRadius="lg"
            border="1px solid"
            borderColor="blue.200"
          >
            <VStack spacing={3} align="start">
              <HStack spacing={2}>
                <Icon as={FaClock} color="blue.500" />
                <Text fontSize="sm" fontWeight="medium" color="blue.700">
                  O que fazer?
                </Text>
              </HStack>
              <VStack spacing={2} align="start">
                <Text fontSize="sm" color="blue.600">
                  • Aguarde alguns minutos e tente novamente
                </Text>
                <Text fontSize="sm" color="blue.600">
                  • Verifique se outros usuários estão usando o sistema
                </Text>
                <Text fontSize="sm" color="blue.600">
                  • Entre em contato com o suporte se o problema persistir
                </Text>
              </VStack>
            </VStack>
          </Box>

          {/* Botões de ação */}
          <VStack spacing={3} pt={4}>
            {showRetry && (
              <Button
                colorScheme="blue"
                size="lg"
                w="100%"
                onClick={onRetry}
                borderRadius="xl"
                fontWeight="bold"
                fontSize="md"
                py={6}
                _hover={{ transform: "translateY(-2px)", boxShadow: "lg" }}
                transition="all 0.2s"
              >
                Tentar Novamente
              </Button>
            )}
            
            {showBack && (
              <Button
                colorScheme="gray"
                variant="outline"
                size="lg"
                w="100%"
                onClick={onBack}
                borderRadius="xl"
                fontWeight="bold"
                fontSize="md"
                py={6}
                _hover={{ bg: "gray.50", transform: "translateY(-2px)", boxShadow: "md" }}
                transition="all 0.2s"
              >
                Voltar
              </Button>
            )}
          </VStack>
        </VStack>
      </Box>
    </Box>
  );
};

export default LicenseErrorAlert;
